import React from "react";
import PropTypes from 'prop-types';
import ReactDOM from "react-dom";

import { connect } from 'react-redux';

import { ObtenerHistoricoTarifasEnAPI, GetProveedoresEnAPI, GetMarcaProveedorEnAPI } from "../../action/actionCreatorsRequests";
import {
    MSGOK, recortarCadena, obtenerUsuario, obtenerToken, traducirPagina

} from "../../librerias/funciones"

import { Button, Modal, Select, Row, Col, Pagination } from 'antd';
import {
    MenuOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    EyeOutlined

} from '@ant-design/icons';


import { Layout } from 'antd';
import { CPDia_Mes_Anyo } from "../CPDiaMesAnyo";
import FichaActualizacion from "./FichaActualizacion";
const { Content } = Layout;
const { Option } = Select;

const MantenimientoActualizaciones = ({ activeItemReferencia, props }) => {
    const [abrirFicha, setAbrirFicha] = React.useState(false);
    const [proveedores, seProveedores] = React.useState([]);
    const [marcas, setMarcas] = React.useState([]);



    const [ordenTabla, setOrdenTabla] = React.useState({
        ORDER_DIR: "D",
        ORDER_COLUM: 4,
        NUM_COLUM: 4,
        ACTIVO: false
    });


    const [bloqueoPantalla, setBloqueoPantalla] = React.useState({
        LOADER: false,
        MENSAJE: ""
    });



    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [tarifas, setTarifas] = React.useState([]);
    const [totalRegistros, setTotalRegistros] = React.useState(0);

    const [registroProveedor, setRegistroProveedor] = React.useState([]);
    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });
    const [filtroLocal, setFiltroLocal] = React.useState({
        ID_GRUPO_MONTAJE: null,
        TEXTO_BUSCADOR: "",
        LOADER_CSV: false,
        FECHA_PARTIDA: "",
        ID_PROVEEDOR: 0,
        ID_MARCA: 0,
        FECHA_PARTIDA: "",
        ACCION_DESDE: 0,
        ACCION_HASTA: 0,
        ACCION_GRUPAL: 0,
        ULTIMAS: false,
        FUTURAS: false
    });







    const GetProveedores = (ORDERCOLUM, ORDERDIR, ID) => {
        seProveedores([]);
        GetProveedoresEnAPI(ORDERCOLUM, ORDERDIR, ID, null).then((licencias) => {
            if (licencias !== undefined) {
                if (licencias.REGISTROS !== null && licencias.REGISTROS.length > 0) {
                    seProveedores(licencias.REGISTROS);

                } else {
                    seProveedores(null)
                }
            }
        })
    }


    const GetMarcaProveedor = (ID_PROVEEDOR) => {
        setMarcas([])

        GetMarcaProveedorEnAPI(ID_PROVEEDOR).then((licencias) => {
            if (licencias !== undefined) {
                if (licencias.REGISTROS !== null && licencias.REGISTROS.length > 0) {
                    setMarcas(licencias.REGISTROS)
                } else {
                    setMarcas(null)
                }
            }
        })
    }



    const colorPrecio = (PRECIO) => {
        let COLOR = "#dcdcdc";
        let RESULTADO = { COLOR, INCREMENTO: null }

        if (PRECIO !== undefined && PRECIO !== null && PRECIO !== "") {
            let IMPORTE = parseFloat(PRECIO)
            if (IMPORTE > 0) {
                COLOR = "green"
            } else if (IMPORTE < 0) {
                COLOR = "red"
            }
            RESULTADO = { COLOR, INCREMENTO: IMPORTE === 0 ? null : IMPORTE > 0 }
        }
        return RESULTADO;
    }


    const ObtenerHistoricoTarifas = async (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, ID_PROVEEDOR, ID_MARCA, FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, ACCION_ULTIMAS, ACCION_FUTURAS) => {
        bloqueoPantalla.LOADER = true;
        bloqueoPantalla.MENSAJE = "";
        setBloqueoPantalla({ ...bloqueoPantalla })

        if(ACCION_ULTIMAS || ACCION_FUTURAS){
            FECHA_PARTIDA = null
        }

        setTarifas([])
        let registro = await ObtenerHistoricoTarifasEnAPI(REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, ID_PROVEEDOR, ID_MARCA, FECHA_PARTIDA, false, ACCION_DESDE, ACCION_HASTA, ACCION_ULTIMAS ? 1 : 0, ACCION_FUTURAS ? 1 : 0)
        bloqueoPantalla.LOADER = false;
        bloqueoPantalla.MENSAJE = "";
        setBloqueoPantalla({ ...bloqueoPantalla })

        if (registro !== undefined) {
            if (registro !== null && registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
                setTarifas(registro.REGISTROS)
                setTotalRegistros(registro.TOTAL_REGISTROS)
            } else {
                setTarifas(null)
                setTotalRegistros(0)
            }
        }
        return registro;
    }


    const ordenacionTabla = (ORDER_COLUM, ORDER_DIR) => {
        ObtenerHistoricoTarifas(datosPaginacion.numPagina, datosPaginacion.iniPage, ORDER_COLUM, ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)
    }


    const actualizarTablaFecha = (OBJ_FECHA) => {
        const { FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA } = OBJ_FECHA
        filtroLocal.FECHA_PARTIDA = FECHA_PARTIDA;
        filtroLocal.ACCION_DESDE = ACCION_DESDE;
        filtroLocal.ACCION_HASTA = ACCION_HASTA;
        filtroLocal.ULTIMAS = false
        filtroLocal.FUTURAS = false
        setFiltroLocal({ ...filtroLocal })

        ObtenerHistoricoTarifas(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)
    }



    const desactivarFecha = () => {

        if (document.getElementById("cp_dia") !== null) {
            let dia = document.getElementById("cp_dia");
            dia.classList.add("cp_dia");

        }

        if (document.getElementById("cp_mes") !== null) {
            let mes = document.getElementById("cp_mes");
            mes.classList.add("cp_mes");
        }

        if (document.getElementById("cp_anio") !== null) {
            let anio = document.getElementById("cp_anio");
            anio.classList.add("cp_anio");
        }
    }

    
    
    const activarFecha = () => {
        if (document.getElementById("cp_dia") !== null) {
            let dia = document.getElementById("cp_dia");
            dia.classList.remove("cp_dia");
        }

        if (document.getElementById("cp_mes") !== null) {
            let mes = document.getElementById("cp_mes");
            mes.classList.remove("cp_mes");
        }

        if (document.getElementById("cp_anio") !== null) {
            let anio = document.getElementById("cp_anio");
            anio.classList.remove("cp_anio");
        }
    }



    const initFecha = (OBJ_FECHA) => {

        const { FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA } = OBJ_FECHA
        filtroLocal.FECHA_PARTIDA = FECHA_PARTIDA;
        filtroLocal.ACCION_DESDE = ACCION_DESDE;
        filtroLocal.ACCION_HASTA = ACCION_HASTA;
        setFiltroLocal({ ...filtroLocal })



        ObtenerHistoricoTarifas(40, 1, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)



    }

    /*
    if (!hayLicencias && activeItemReferencia === "MANTENIMIENTO_ACTUALIZACIONES") {
        seHayLicencias(true)

        GetProveedores(1, "A", "");

    } else {
        if (activeItemReferencia !== "MANTENIMIENTO_ACTUALIZACIONES" && hayLicencias) {
            seHayLicencias(false)
        }
    }
*/


    const paginarTabla = (page, pageSize) => {
        if (totalRegistros > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;
            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )

            ObtenerHistoricoTarifas(pageSize, page, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)
        }
    }

    //verificar
    const updateNumberPage = (current, size) => {
        ObtenerHistoricoTarifas(size, current, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)
        setDatosPaginacion(
            {
                iniPage: current,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })




    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            GetProveedores(1, "A", "");
            GetMarcaProveedor(null);
        }
    }, [])





    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {traducirPagina("ACTUALIZACIONES_TARIFAS").toUpperCase()}
        </>,
        document.getElementById("tituloMenu")
    );


    return (
        <>
            <div className="menu_mantenimiento" ref={ref}>
                <div className='mantenimiento_item1'>
                    {
                        totalRegistros > 0 ?
                            <Pagination
                                showSizeChanger
                                current={datosPaginacion.iniPage}
                                onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                total={totalRegistros}
                                showTotal={() => ` ${totalRegistros} ${traducirPagina("registros")}`}
                                defaultPageSize={40}
                                onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                            > </Pagination>
                            :
                            null
                    }
                </div>

                <div className='mantenimiento_item2' style={{ gap: '10px' }}>
                    <div>
                        {proveedores !== null ?
                            <Select
                                showSearch
                                allowClear={true}
                                value={filtroLocal.ID_PROVEEDOR === null || filtroLocal.ID_PROVEEDOR === 0 ? traducirPagina("Seleccione_un_proveedor") : filtroLocal.ID_PROVEEDOR}
                                style={{ width: '250px' }}
                                size={"large"}
                                placeholder={traducirPagina("Seleccione_un_proveedor")}
                                onChange={(e) => {
                                    if (e === undefined || e === null) {
                                        filtroLocal.ID_PROVEEDOR = null
                                        filtroLocal.ID_MARCA = null
                                        setMarcas([])

                                        setFiltroLocal({ ...filtroLocal })
                                    } else {
                                        filtroLocal.ID_PROVEEDOR = e
                                        GetMarcaProveedor(e)
                                        setFiltroLocal({ ...filtroLocal })
                                    }


                                    ObtenerHistoricoTarifas(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, filtroLocal.ID_PROVEEDOR, filtroLocal.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)

                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {proveedores.length > 0 ?
                                    proveedores.map((registro) =>
                                        <Option key={registro.ID} value={registro.ID}>{registro.NOMBRE_COMERCIAL}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Sin_resultados")}</h4>
                            </div>
                        }
                    </div>

                    <div>
                        {marcas !== null ?
                            <Select
                                showSearch
                                allowClear={true}
                                value={filtroLocal.ID_MARCA === null || filtroLocal.ID_MARCA === 0 ? traducirPagina("Seleccion_marca") : filtroLocal.ID_MARCA}
                                style={{ width: '250px' }}

                                size={"large"}
                                placeholder={traducirPagina("Seleccion_marca")}
                                onChange={(e) => {
                                    if (e === undefined || e === null) {
                                        filtroLocal.ID_MARCA = null

                                        setFiltroLocal({ ...filtroLocal })
                                    } else {
                                        filtroLocal.ID_MARCA = e

                                        setFiltroLocal({ ...filtroLocal })
                                    }

                                    ObtenerHistoricoTarifas(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, filtroLocal.ID_PROVEEDOR, filtroLocal.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)


                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {marcas.length > 0 ?
                                    marcas.map((registro) =>
                                        <Option key={registro.ID_MARCA} value={registro.ID_MARCA}>{registro.NOMBRE_MARCA}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Sin_resultados")}</h4>
                            </div>
                        }
                    </div>

                    <div className="btn_grupal">
                        <div onClick={() => {
                            filtroLocal.ULTIMAS = !filtroLocal.ULTIMAS;
                            filtroLocal.FUTURAS = false;
                            filtroLocal.ULTIMAS || filtroLocal.FUTURAS ? desactivarFecha():activarFecha()

                            
                            setFiltroLocal({ ...filtroLocal })
                            ObtenerHistoricoTarifas(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)
                        }}
                            style={{ background: filtroLocal.ULTIMAS && '#00468e' }}>{traducirPagina("Ultimas")}</div>

                        <div onClick={() => {
                            filtroLocal.FUTURAS = !filtroLocal.FUTURAS;
                            filtroLocal.ULTIMAS = false;
                            filtroLocal.FUTURAS || filtroLocal.ULTIMAS ?  desactivarFecha():activarFecha()

                            setFiltroLocal({ ...filtroLocal })
                            ObtenerHistoricoTarifas(datosPaginacion.numPagina, datosPaginacion.iniPage, ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR, null, props.ID_PROVEEDOR, props.ID_MARCA, filtroLocal.FECHA_PARTIDA, filtroLocal.ACCION_DESDE, filtroLocal.ACCION_HASTA, filtroLocal.ULTIMAS, filtroLocal.FUTURAS)

                        }}
                            style={{ background: filtroLocal.FUTURAS && '#00468e' }}>{traducirPagina("Futuras")}</div>
                    </div>


                    <CPDia_Mes_Anyo
                        ANYOS={[]}
                        ACTUALIZAR_TABLA={actualizarTablaFecha}
                        FECHA_INICIAL={initFecha}
                        OCULTAR_DIA={false}
                    >
                    </CPDia_Mes_Anyo>

                </div>
            </div>


            <div className="margen_tabla">


                <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>

                    <table style={{ width: '100%', color: '#000' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#e0e0e0' }}>

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 1

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 1 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 1
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '250px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }} >{traducirPagina("Proveedor")} {ordenTabla.NUM_COLUM === 1 && ordenTabla.ACTIVO ? <ArrowUpOutlined className={ordenTabla.ORDER_COLUM === 1 ? "quitar_opacity_icono":"poner_opacity_icono" } ></ArrowUpOutlined> : <ArrowDownOutlined className={ordenTabla.ORDER_COLUM === 1? "quitar_opacity_icono":"poner_opacity_icono" }></ArrowDownOutlined>}</th>

                                <th className="formatear_cabecera_icono" style={{ width: '250px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}
                                    onClick={(e) => {
                                        // actiual arrow-down
                                        const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                        ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                        ordenTabla.NUM_COLUM = 2

                                        ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 2 && ordenTabla.ACTIVO ? "A" : "D"
                                        ordenTabla.ORDER_COLUM = 2
                                        setOrdenTabla({ ...ordenTabla })

                                        ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)
                                    }}
                                >{traducirPagina("Marca")} {ordenTabla.NUM_COLUM === 2 && ordenTabla.ACTIVO ? <ArrowUpOutlined className={ordenTabla.ORDER_COLUM === 2 ? "quitar_opacity_icono":"poner_opacity_icono"}></ArrowUpOutlined> : <ArrowDownOutlined className={ordenTabla.ORDER_COLUM === 2 ? "quitar_opacity_icono":"poner_opacity_icono"}></ArrowDownOutlined>} </th>



                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 3

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 3 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 3
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Vigencia")} {ordenTabla.NUM_COLUM === 3 && ordenTabla.ACTIVO ? <ArrowUpOutlined className={ordenTabla.ORDER_COLUM === 3 ? "quitar_opacity_icono":"poner_opacity_icono"}></ArrowUpOutlined> : <ArrowDownOutlined className={ordenTabla.ORDER_COLUM === 3 ? "quitar_opacity_icono":"poner_opacity_icono"}></ArrowDownOutlined>}</th>

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                    const ICONO_ACTUAL = e.currentTarget.children[0].ariaLabel;
                                    ordenTabla.ACTIVO = ICONO_ACTUAL === "arrow-down" ? true : false
                                    ordenTabla.NUM_COLUM = 4

                                    ordenTabla.ORDER_DIR = ordenTabla.NUM_COLUM === 4 && ordenTabla.ACTIVO ? "A" : "D"
                                    ordenTabla.ORDER_COLUM = 4
                                    setOrdenTabla({ ...ordenTabla })

                                    ordenacionTabla(ordenTabla.ORDER_COLUM, ordenTabla.ORDER_DIR)

                                }}
                                    style={{ width: '170px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Actualizacion")} {ordenTabla.NUM_COLUM === 4 && ordenTabla.ACTIVO ? <ArrowUpOutlined className={ordenTabla.ORDER_COLUM === 4 ? "quitar_opacity_icono":"poner_opacity_icono"}></ArrowUpOutlined> : <ArrowDownOutlined className={ordenTabla.ORDER_COLUM === 4 ? "quitar_opacity_icono":"poner_opacity_icono"}></ArrowDownOutlined>}</th>

                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                }}
                                    style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Observaciones")}</th>


                                <th className="formatear_cabecera_icono" onClick={(e) => {
                                }}
                                    style={{ width: '50px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>

                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {tarifas === null ?
                                null
                                :
                                tarifas !== null && tarifas.length > 0 ?
                                    tarifas.map((registro, i) =>
                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.PROVEEDOR}</td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{`${registro.MARCA}`}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.FECHA_VIGENCIA}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{`${registro.FECHA_ACTUALIZACION} `}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.OBSERVACION}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                <div style={{ margin: '0px 2px' }}>
                                                    <button
                                                        onClick={() => {
                                                            /*
                                                            setAbrirFichaProveedor(true)
                                                            setRegistroProveedor(licencia)
                                                            */
                                                            setRegistroProveedor(registro)

                                                            setAbrirFicha(true)
                                                        }}
                                                        className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                        <EyeOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                    </button>
                                                </div>


                                            </td>

                                        </tr>
                                    )
                                    :
                                    null

                            }
                        </tbody>
                    </table>

                    {tarifas === null ?
                        <div>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>

                        </div>
                        :
                        tarifas !== null && tarifas.length > 0 ?
                            null
                            :
                            <div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                            </div>
                    }

                    {
                        abrirFicha ?
                            <FichaActualizacion
                                title={`${traducirPagina("ACTUALIZACION_PRECIOS_DEL")} ${registroProveedor.FECHA_ACTUALIZACION}`}

                                ABRIR_FICHA={abrirFicha}
                                CERRAR_FICHA={setAbrirFicha}
                                ID_ACTUALIZACION={registroProveedor.ID}
                                ID_PROVEEDOR={registroProveedor.ID_PROVEEDOR}
                                ID_MARCA={registroProveedor.ID_MARCA}
                                NOMBRE_MARCA={registroProveedor.MARCA}
                            >

                            </FichaActualizacion>
                            :
                            null
                    }

                </div>
            </div>
        </>
    );
}


MantenimientoActualizaciones.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        configApp: state.configApp,
        usuario: state.usuario,
        clienteSeleccionado: state.clienteSeleccionado,
        activeItemReferencia: state.activeItemReferencia,

    };
}

export default connect(mapStateToProps)(MantenimientoActualizaciones);





